import { render } from "./App.vue?vue&type=template&id=4c7b9dae&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4c7b9dae&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=4c7b9dae&lang=css"

import exportComponent from "/Users/dcoffey/projects/pubnub-chat/live-chat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7b9dae"]])

export default __exports__